import base from './base'

let controller = 'companyCreditRecord'
let action = null

const CompanyCreditRecord = {
  async listCompanyCreditRecord (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListCompanyCreditRecord'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addCompanyCreditRecord (request) {
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async updateCompanyCreditRecord (request) {
    if (!request.tid) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${request.tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async deleteCompanyCreditRecord (companyCreditRecordId) {
    if (!companyCreditRecordId) {
      throw new Error('Id为空')
    }
    action = `Delete/${companyCreditRecordId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async detail (companyCreditRecordId) {
    if (!companyCreditRecordId) {
      throw new Error('Id为空')
    }
    action = `Detail/${companyCreditRecordId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default CompanyCreditRecord